import styled from 'styled-components';

export const ContentParserWrapper = styled.div`
  p,
  blockquote,
  ul,
  ol,
  dl,
  table,
  pre {
    margin-top: 0;
    margin-bottom: 16px;
  }
  h1,
  h2,
  h3 {
    margin-top: 24px;
    margin-bottom: 16px;
    font-weight: ${({ theme }) => theme.fontWeights.medium};
    line-height: 1.25;
    border-bottom: 1px solid #eee;
    padding-bottom: 0.3em;
  }
  h1 {
    font-size: 1.6em;
  }
  h2 {
    font-size: 1.4em;
  }
  h3 {
    font-size: 1.2em;
  }
  ul,
  ol {
    padding-left: 1.2em;
  }
  blockquote {
    margin-left: 0;
    padding: 0 1em;
    color: #777;
    border-left: 0.25em solid #ddd;
    & > :first-child {
      margin-top: 0;
    }
    & > :last-child {
      margin-bottom: 0;
    }
  }
  code {
    padding: 0.2em 0 0.2em 0;
    margin: 0;
    font-size: 90%;
    background-color: rgba(0, 0, 0, 0.04);
    border-radius: 3px;
    &:before,
    &:after {
      letter-spacing: -0.2em;
      content: '\\00a0';
    }
  }
  pre {
    padding: 16px;
    overflow: auto;
    font-size: 85%;
    line-height: 1.45;
    background-color: #f7f7f7;
    border-radius: 3px;

    code {
      display: inline;
      padding: 0;
      margin: 0;
      overflow: visible;
      line-height: inherit;
      word-wrap: normal;
      background-color: transparent;
      border: 0;
      &::before,
      &::after {
        content: none;
      }
    }

    > code {
      padding: 0;
      margin: 0;
      font-size: 100%;
      word-break: normal;
      white-space: pre;
      background: transparent;
      border: 0;
    }
  }

  input[type='checkbox'] {
    margin-right: 5px;
  }
`;

export const HtmlParserWrapper = styled(ContentParserWrapper)`
  margin-bottom: 10px;
`;
